define([
	"csi/config",
	"csi/xml",
	"dojo/_base/declare",
	"SiteAdmin/AttributeMap/AttributeMapTable"
], function(config,xml,declare,AttributeMapTable) {

	var SETTINGS_URL = "centric://REFLECTION/INSTANCE/MaterialPlanPlacementConfig/Settings";
	var SETUP_SETTINGS_URL = "centric://REFLECTION/INSTANCE/MaterialPlanPlacementConfig/SetupSettings";
	var MAP_SETTING_ID = "BOMLineAttributeMap";
	var MAP_ENTRY_NODE_TYPE = "_BOMLineAttributeMapEntry_";
	var DEST_ATTR_ID_ATTR = "BOMLineAttributeId";
	var LOCKED_MAP = "BOMLineAttributePerBOMSubtypeLockedMap";

	AttributeMapTable.watchValueDropDown(MAP_ENTRY_NODE_TYPE, DEST_ATTR_ID_ATTR);

	return declare(AttributeMapTable, {
		settingsUrl: SETTINGS_URL,
		setupSettingsUrl: SETUP_SETTINGS_URL,
		mapSettingId: MAP_SETTING_ID,
		mapEntryNodeType: MAP_ENTRY_NODE_TYPE,
		destAttrIdAttr: DEST_ATTR_ID_ATTR,
		currentExceptionReportKey: config.getClassSetting("MaterialPlanPlacement","ExceptionReportKey"),
		sourceClassName: "MaterialPlanPlacement",

		onAccessActionLockedMap: function(ac) {
		    var node = ac.getNodeContext();
		    return !!node.BOMLineAttributeId;
		},

		postActionChangeLockedMap: function(ac) {
			var node = this.getRowNode(ac.m_element);
			node["AppliedOn"] = 0;
			node["Modified"] = true;
			this.postActionRefreshNode(ac);
			ac.m_writer.changeNode(ac.widget.setupSettingsUrl).changeAttribute("Modified", xml.ATTR_BOOLEAN, true)
		},

		_getModified: function(sourceAttrId) {
			var map = this._getSettings()[LOCKED_MAP];
			var setUpMap = this._getSetupSettings()[LOCKED_MAP];
			var sourceAttrEntriesMap = this._findValueByPrefix(map, sourceAttrId);
			var sourceAttrEntriesSetUpMap = this._findValueByPrefix(setUpMap, sourceAttrId);
			if (sourceAttrEntriesMap.length != sourceAttrEntriesSetUpMap.length)
				return true;

			return sourceAttrEntriesMap.toString() != sourceAttrEntriesMap.toString();
		},

		_findValueByPrefix: function(object, prefix) {
			var entries = [];
			for (var property in object) {
				if (object.hasOwnProperty(property) &&
						property.toString().startsWith(prefix)) {
						entries.push(object[property]);
				}
			}
			return entries;
		}

	});
});
